import React from 'react';
import { PeriodontalObject } from '../../Interfaces/PeriodontalObject.interface';
import DENTModalOverviewPeriodontalItemModal from '../DENTModalOverviewPeriodontalItem/DENTModalOverviewPeriodontalItemModal';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalItems.module.scss';
import { useDENTContext } from '../../Services/DENTContext';
import { OverviewMode } from '../../Enums/OverviewMode.enum';

interface Props {
	options: PeriodontalObject[];
}

const DENTModalOverviewPeriodontalItems = ({ options }: Props) => {
	const { activePeriodontalItem, setActivePeriodontalItem, overviewMode } =
		useDENTContext();

	if (!activePeriodontalItem) {
		setActivePeriodontalItem(options[0].type);
	}

	return (
		<div
			className={
				overviewMode === OverviewMode.PERIODONTAL
					? styles.quickAdjustmentWrapper
					: styles.wrapper
			}>
			{options.map(option => (
				<DENTModalOverviewPeriodontalItemModal
					key={option.type}
					periodontalItem={option}
					onClick={() => setActivePeriodontalItem(option.type)}
					isSelected={activePeriodontalItem === option.type}
				/>
			))}
		</div>
	);
};

export default DENTModalOverviewPeriodontalItems;
